import * as React from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import Head from "../components/head"

const IndexPage = ({ data }) => {
  return (
    <Layout>
      <div>
        <main>
          <Head title="Skulpturen" />

          <div className="mx-auto">
            <GatsbyImage image={data.file.childImageSharp.gatsbyImageData} />
          </div>
        </main>
      </div>
    </Layout>
  )
}

export default IndexPage

export const query = graphql`
  query {
    file(relativePath: { eq: "front.jpg" }) {
      childImageSharp {
        gatsbyImageData(
          width: 700
          quality: 80
          placeholder: DOMINANT_COLOR
          formats: [AUTO, WEBP, AVIF]
        )
      }
    }
  }
`
